import DescriptionList from "./DescriptionList";
import Description from "./Description";

DescriptionList.Description = Description;
export default DescriptionList;



// WEBPACK FOOTER //
// ./src/components/comm/DescriptionList/index.js